<mat-accordion>
  @for (lead of leadsWithOrder.reachableLeads; let i = $index; track lead.id) {
    <app-mat-extension-panel-lead
      [lead]="lead"
      [number]="i + 1"
    ></app-mat-extension-panel-lead>
  }
  @if (leadsWithOrder.unreachableLeads.length > 0) {
    <div>
      <p>
        {{ "components.selected-lead-list.unreachable-leads-text" | translate }}
      </p>
      @for (
        lead of leadsWithOrder.unreachableLeads;
        let i = $index;
        track lead.id
      ) {
        <app-mat-extension-panel-lead
          [lead]="lead"
          [number]="i + 1"
        ></app-mat-extension-panel-lead>
      }
    </div>
  }
</mat-accordion>
